<template>
  <div id="app" class="font-sans antialiased">
    <template v-if="showLayout">
      <AppShell>
        <router-view v-slot="{ Component }">
          <transition
            enter-active-class="transition duration-200 ease-out"
            enter-from-class="opacity-0 translate-y-1"
            enter-to-class="opacity-100 translate-y-0"
            mode="out-in"
          >
            <component :is="Component" />
          </transition>
        </router-view>
      </AppShell>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script setup>
import { computed, onMounted, provide } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import AppShell from '@/components/layout/AppShell.vue'

const route = useRoute()
const authStore = useAuthStore()

const showLayout = computed(() => {
  if (route.name === 'Login') return false
  if (route.name === 'SelectEstablishment') return false
  if (route.name === 'NotFound' && !authStore.isAuthenticated) return false
  return authStore.isAuthenticated
})

const handleRefreshNotifications = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('refresh-notifications'))
  }
}

provide('refreshNotifications', handleRefreshNotifications)

onMounted(async () => {
  if (authStore.token && !authStore.currentUser) {
    try {
      await authStore.fetchCurrentUser()
    } catch (error) {
      console.error('Failed to fetch user on app mount:', error)
      authStore.logout()
    }
  }
})
</script>
